import React from "react";
import MVMIcon from "../../Common/MVMIcon";
import { ExerciseOptions } from "@/common/constants";
import BootstrapIcon from "../../Common/BootstrapIcon";
import ImageWithPlaceholder from "../../Common/ImageWithPlaceholder";
const PostDistanceModalContent = (props) => {
    const { formData, onSubmit, distanceUnit, missions, isPosting } = props;
    if (!formData)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: 'modal-content' },
        React.createElement("div", { className: 'modal-header' },
            React.createElement("h3", { className: 'modal-title' }, "Please confirm the details of your activity"),
            React.createElement("button", { type: 'button', className: 'btn-close', "data-bs-dismiss": 'modal', "aria-label": 'Close' })),
        React.createElement("div", { className: 'modal-body' },
            React.createElement("div", { className: 'my-2 d-flex align-items-center' },
                React.createElement("div", null,
                    React.createElement(MVMIcon, { icon: 'distance', height: 25, width: 25 })),
                React.createElement("p", { className: 'ms-2 mb-0' },
                    formData.travelled,
                    " ",
                    distanceUnit.toLowerCase(),
                    " -",
                    " ",
                    ExerciseOptions[formData.exerciseType])),
            React.createElement("div", { className: 'my-2 d-flex align-items-center' },
                React.createElement("div", null,
                    React.createElement(BootstrapIcon, { icon: 'calendar3', height: 25, width: 25 })),
                React.createElement("p", { className: 'ms-2 mb-0' }, formData.startDate)),
            formData.comment !== "" && (React.createElement("div", { className: 'my-2 d-flex' },
                React.createElement("div", null,
                    React.createElement(BootstrapIcon, { icon: 'chat-text', height: 25, width: 25 })),
                React.createElement("p", { className: 'ms-2 mb-0' }, formData.comment))),
            formData.filePath !== "" && (React.createElement("img", { className: 'img-fluid', src: "/" + formData.filePath })),
            React.createElement("p", { className: 'primary-color mt-4 mb-0' }, "POSTING TO:"),
            missions?.map((mission, index) => (React.createElement(React.Fragment, { key: mission.id },
                React.createElement("div", { className: `d-flex align-items-center ${index !== 0 && "border-top"}` },
                    React.createElement(ImageWithPlaceholder, { src: mission.image, className: 'post-distance-mission-avatar', type: 'mission' }),
                    React.createElement("p", { className: 'm-0' }, mission.name)))))),
        React.createElement("div", { className: 'modal-footer' },
            React.createElement("a", { href: '#', className: 'small-btn', "data-bs-dismiss": 'modal' }, "Cancel"),
            React.createElement("a", { href: '#', id: 'confirm-post', className: `small-btn-primary ${isPosting && "disabled"}`, onClick: onSubmit },
                isPosting && (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: 'spinner-border spinner-border-sm', role: 'status', "aria-hidden": 'true' }),
                    " ")),
                "Confirm"))));
};
export default PostDistanceModalContent;
